import { useState } from 'react';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronRight,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import CommonItemInfo from './CommonItemInfo';
import StarRating from './StarRating';

const amazonItemStyles = css`
.infoBox {
  display: flex;
  column-gap: 30px;
  row-gap: 10px;
  padding-top: 5px;
  flex-wrap: wrap;

  &.closed {
    display: none;
  }
}

.commentBox {
  align-self: center;
  background-color: #f0f0f0;
  padding: 10px;
  font-style: italic;
  font-size: 0.75em;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 3px;
  max-width: 300px;
  flex-grow: 1 ;
}

.requested {
  font-size: 0.75em;
}

.info {
  font-size: 0.75em;
  display: flex;
  .entry {
    padding-right: 5px;
    padding-left: 5px;
    border-right: 1px solid black;

    &:last-child {
      border: none;
    }
    &:first-child {
      padding-left: 0px;
    }
  }
}`

const AmazonItem = styled(({ className, item, toggleLike }) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const ratingArr = item.stars?.split(' ');
  const stars = ratingArr?.[0];
  const requestedText = item.requested ? `Needs ${item.requested}  Has ${item.purchased}` : null;
  const info = Object.entries(item.info).map(([k, v], i) => <span key={i} className='entry'>{`${k}: ${v}`}</span>);
  const itemPriorityLabels = {
    '-2': 'Lowest',
    '-1': 'Low',
    '0': 'Medium',
    '1': 'High',
    '2': 'Highest'
  };
  const priorityText = item.priority !== '' ? itemPriorityLabels[item.priority] ?? '' : '';

  return (
    <div className={className}>
      <CommonItemInfo item={item} toggleLike = {toggleLike} >
        {/* <div className={`expander ${isExpanded ? 'open' : 'closed'}`} onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? <FontAwesomeIcon icon={faChevronDown} /> : <FontAwesomeIcon icon={faChevronRight} />}
        </div> */}
        <div className={`infoBox ${isExpanded ? '' : 'closed'}`}>
          <div>
            <StarRating value={stars} reviewCount={item.reviewCount} text={item.stars} />
            {info.length > 0 && <div className='info'>{info} </div>}
            {requestedText && <div className='requested'>{requestedText}</div>}
            <div className='addedOn'>{item.addedOn}</div>
          </div>
          {
            (item.comment || priorityText) &&
            <div className='commentBox'>
              {item.comment && <div className='comment'>{`"${item.comment}"`}</div>}
              {priorityText && <div className='priority'>{`${priorityText} priority`}</div>}
            </div>
          }
        </div>
      </CommonItemInfo>
    </div>
  )
})`${amazonItemStyles}`;

export default AmazonItem;
